export default {
  customers: null,
  totalCustomers: null,
  notes: null,
  customerMetadatas: null
};
